import { render, staticRenderFns } from "./clientdashboard-profile-bso.vue?vue&type=template&id=024115bf&"
import script from "./clientdashboard-profile-bso.vue?vue&type=script&lang=js&"
export * from "./clientdashboard-profile-bso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports